import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormData, useFormFields } from '../../../store/selectors/formStore';
import { FORM_FIELDS } from '../../../constants';
import { TaskManager } from '../../../helpers/form.new/task.manager';
import { extendFormData } from '../../../store/reducers/formStore';
import { getAddress } from '../../../helpers/form.new/tasks/get.address';

export const useAddressNormalizer = (taskManager: TaskManager) => {
    const dispatch = useDispatch();
    const formData = useFormData();
    const [registrationStreet, residenceStreet] = useFormFields([
        FORM_FIELDS.REGISTRATION_STREET,
        FORM_FIELDS.RESIDENCE_STREET,
    ]);

    useEffect(() => {
        if (registrationStreet || residenceStreet) {
            taskManager.register(getAddress(formData).then((addressData) => dispatch(extendFormData(addressData))));
        }
    }, []);
};
